export default __webpack_public_path__ + "static/portrait-ef124b2d2e537749f07403e836dc97a6.webp";